import { Pressable, StyleSheet, View } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import {
  DYNAMIC_MODAL_ACTIONS,
  DYNAMIC_MODAL_VIEWS,
  MODAL_QUALITY_OPEN_POINTS,
} from '../../store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { useStore } from '../../contexts/StoreContext';
import { IUserImageModel } from '../../store/_models/userImage';
import { qualityAlertBadgeTestID } from 'src/helpers/testIDs.helper';
import { CtasType } from '../modals/dynamic-modals/modal-quality-alert/ModalQualityAlert.constants';
import { alert, text } from 'src/theme/colors';
import TextLato from '../text/text-lato/TextLato';
import { useRoute } from '@react-navigation/native';
import { ROUTE_NAMES } from 'src/routes/_shared/routes.constants';
import { useEffect } from 'react';

type BadgeQualityAlertProps = {
  userImage: IUserImageModel;
  padding?: number;
};

export const BadgeQualityAlert = ({ userImage, padding = 0 }: BadgeQualityAlertProps) => {
  const {
    dynamicModal: { openModal },
    i18n: { t },
    toastStore: { showQualityAlertToast, removeToast },
    project: { activeProduct, activeGroup },
  } = useStore();

  const route = useRoute();
  const newRoute = [ROUTE_NAMES.EditorNew, ROUTE_NAMES.Edit].includes(route?.name as ROUTE_NAMES);

  const actionCallback = (action: DYNAMIC_MODAL_ACTIONS) => {
    switch (action) {
      case DYNAMIC_MODAL_ACTIONS.HIDE_MODAL:
        // do nothing
        break;
      case DYNAMIC_MODAL_ACTIONS.EXIT:
      case DYNAMIC_MODAL_ACTIONS.IGNORE:
      case DYNAMIC_MODAL_ACTIONS.CLOSE:
        removeToast(alertQualityImageToastId);
        break;
      default:
        removeToast(alertQualityImageToastId);
        break;
    }
  };

  const alertQualityImageToastId = `alert-quality-image-toast-${userImage.id}`;
  const handlePressAlert = (moreImagesHasAlert?: boolean) => {
    if (userImage.qualitySuggestions) {
      openModal({
        qualityAlertUserImage:
          !moreImagesHasAlert || activeGroup?.userImagesWithQualityAlert?.length === 1 ? userImage : undefined,
        modalQualitySuggestions: userImage.qualitySuggestions,
        modalQualityCtas: CtasType.CLOSE,
        modalQualityOpenPoint: MODAL_QUALITY_OPEN_POINTS.photo,
        dynamicModalView: DYNAMIC_MODAL_VIEWS.QualityAlert,
        actionCallback: actionCallback,
      });
    }
  };

  /*   useEffect(() => {
    if (!newRoute) {
      if (userImage.qualityAlert) {
        if (activeProduct?.id === userImage.productId) {
          showQualityAlertToast({
            id: alertQualityImageToastId,
            message: t('toast:suboptimal-quality'),
            ctaText: t('toast:fix'),
            onPress: () => handlePressAlert(),
            removeOnPress: false,
          });
        } else {
          removeToast(alertQualityImageToastId);
        }
      } else {
        removeToast(alertQualityImageToastId);
      }
    }
  }, [activeProduct, userImage.qualityAlert]); */

  return (
    <Pressable
      style={[
        style.badge,
        {
          bottom: style.badge.bottom + padding,
          right: style.badge.right + padding,
        },
      ]}
      onPress={() => handlePressAlert()}
      testID={qualityAlertBadgeTestID(userImage.productId, userImage.userImageAreaId)}
      accessible={true}
      accessibilityLabel={t('customize:suboptimal-quality')}
      accessibilityRole="button"
    >
      <View style={style.icon}>
        <Icon name={ICON_NAMES.Alert} color={neutrals.neutralGrays.tarmac} />
      </View>
    </Pressable>
  );
};

export const BadgeQualityAlertGroup = () => {
  const { i18n } = useStore();
  return (
    <View style={style.badgeWithText}>
      <View style={style.icon}>
        <Icon name={ICON_NAMES.Alert} color={neutrals.neutralGrays.tarmac} />
      </View>
      <TextLato style={style.text}>{i18n.t('modal-quality-alert:quality-check')}</TextLato>
    </View>
  );
};

const style = StyleSheet.create({
  badge: {
    /*  position: 'absolute',
    zIndex: 200,
    bottom: 10,
    right: 10, */
    backgroundColor: brand.main.mustard,
    width: 28,
    height: 28,
    borderWidth: 2,
    borderColor: neutrals.white,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowRadius: 3.8,
  },
  icon: {
    width: 18,
    height: 18,
    marginBottom: 4,
  },
  badgeWithText: {
    flexDirection: 'row',
    //width: 28,
    height: 30,
    borderWidth: 2,
    borderColor: neutrals.white,
    backgroundColor: alert.alertYellow,
    borderRadius: 28,
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowRadius: 3.8,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    gap: 6,
    paddingHorizontal: 10,
  },
  text: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    color: text.secondaryText,
  },
});
